"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.VizClientFieldCard = void 0;
var data_catalog_shared_1 = require("@tableau/data-catalog-shared");
var data_structures_1 = require("@tableau/data-structures");
var widgets_1 = require("@tableau/widgets");
var React = require("react");
var Localize_1 = require("../../../gen-src/Localize");
var FieldPropertyComponents_1 = require("../FieldDetails/FieldPropertyComponents");
var FieldsReferencedByFieldQueryGrid_1 = require("../FieldDetails/FieldsReferencedByFieldQueryGrid");
var FieldFunctions_1 = require("../field/functions/FieldFunctions");
var FieldNameMapping_1 = require("../field/functions/FieldNameMapping");
var LinksDisplayGrid_1 = require("../sharedDisplayGrid/LinksDisplayGrid");
var CalculationDetails_1 = require("./CalculationDetails");
var VizClientFieldCardDescription_1 = require("./VizClientFieldCardDescription");
var VizClientFieldCardStyles_1 = require("./VizClientFieldCardStyles");
var VizClientFieldCard = /** @class */ (function (_super) {
    __extends(VizClientFieldCard, _super);
    function VizClientFieldCard() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    VizClientFieldCard.prototype.renderHeader = function () {
        var fieldIcon = FieldFunctions_1.iconForField(this.props.field);
        return (React.createElement(VizClientFieldCardStyles_1.FieldCardHeaderWrapper, { "data-tb-test-id": 'data-details-field-card-header-test-id' }, fieldIcon ? (React.createElement(VizClientFieldCardStyles_1.FieldCardHeaderFieldType, null, FieldNameMapping_1.FieldNameMappings[fieldIcon]())) : null));
    };
    // TODO: use renderFieldsReferencedByField for BinFields when no router issue has been fixed see TFSID: 1021036
    VizClientFieldCard.prototype.renderFieldsReferencedByField = function (field, title) {
        var count = field.fieldsConnection ? field.fieldsConnection.totalCount : null;
        return (React.createElement(React.Fragment, null,
            React.createElement(VizClientFieldCardStyles_1.FieldCardDetailTitleWrapper, null,
                React.createElement(VizClientFieldCardStyles_1.FieldCardDetailTitle, null, title)),
            React.createElement(VizClientFieldCardStyles_1.FieldsReferencingFieldsWrapper, { style: { height: LinksDisplayGrid_1.getRowHeight(count, FieldPropertyComponents_1.fieldsWrapperMaxRows) } },
                React.createElement(FieldsReferencedByFieldQueryGrid_1.FieldsReferencedByFieldQueryGrid, { fieldId: field.id, rowCount: count, targetBlank: true, useAnchor: true }))));
    };
    VizClientFieldCard.prototype.renderCalculation = function (field) {
        if (field.formula === null) {
            return null;
        }
        return React.createElement(CalculationDetails_1.CalculationDetails, { field: field, workbookVizportalUrlId: this.props.workbookVizportalUrlId });
    };
    VizClientFieldCard.prototype.renderBinSize = function (binSize) {
        if (binSize === null) {
            return null;
        }
        return (React.createElement("div", { "data-tb-test-id": 'data-details-bin-size-test-id' },
            React.createElement(VizClientFieldCardStyles_1.FieldCardDetailTitleWrapper, null,
                React.createElement(VizClientFieldCardStyles_1.FieldCardDetailTitle, null, Localize_1.Messages.FieldDetails_BinSize())),
            React.createElement(VizClientFieldCardStyles_1.FieldCardDetailText, null, binSize)));
    };
    VizClientFieldCard.prototype.renderFieldDetailsLink = function () {
        var _this = this;
        if (!this.props.workbookVizportalUrlId) {
            return null;
        }
        return (React.createElement(data_catalog_shared_1.SiteUrlsContext.Consumer, null, function (urls) {
            return React.createElement(widgets_1.TextLinkWidget, { href: urls.workbookLineageFieldUrl(_this.props.workbookVizportalUrlId ? _this.props.workbookVizportalUrlId : '', _this.props.field.id), target: '_blank', testId: 'data-details-field-view-more-link-test-id' }, Localize_1.Messages.ViewMore());
        }));
    };
    VizClientFieldCard.prototype.renderTypeSpecificFieldDetails = function () {
        if (this.props.field.__typename !== 'DatasourceField') {
            return this.renderTypeSpecificNonDatasourceFieldDetails(this.props.field);
        }
        else if (this.props.field.remoteField) {
            return this.renderTypeSpecificNonDatasourceFieldDetails(this.props.field.remoteField);
        }
        else {
            return null;
        }
    };
    VizClientFieldCard.prototype.renderTypeSpecificNonDatasourceFieldDetails = function (field) {
        switch (field.__typename) {
            case 'BinField':
                return (React.createElement(React.Fragment, null,
                    this.renderBinSize(field.binSize),
                    this.renderFieldsReferencedByField(field, Localize_1.Messages.ReferencedFields())));
            case 'CalculatedField':
                return (React.createElement(React.Fragment, null, this.renderCalculation(field)));
            case 'GroupField':
                return (React.createElement(React.Fragment, null, this.renderFieldsReferencedByField(field, Localize_1.Messages.GroupedFields())));
            case 'CombinedField':
            case 'CombinedSetField':
                return (React.createElement(React.Fragment, null, this.renderFieldsReferencedByField(field, Localize_1.Messages.CombinedFields())));
            case 'HierarchyField':
            case 'SetField':
                return (React.createElement(React.Fragment, null, this.renderFieldsReferencedByField(field, Localize_1.Messages.ReferencedFields())));
            case 'ColumnField':
            case 'DatasourceField':
                return null;
            default:
                data_structures_1.assertNever(field);
                return null;
        }
    };
    VizClientFieldCard.prototype.render = function () {
        return (React.createElement(VizClientFieldCardStyles_1.FieldCard, { "data-tb-test-id": 'data-details-field-card-test-id' },
            React.createElement(VizClientFieldCardStyles_1.FieldCardWrapper, null,
                this.renderHeader(),
                React.createElement(VizClientFieldCardStyles_1.FieldCardDetailsWrapper, null,
                    React.createElement(VizClientFieldCardDescription_1.VizClientFieldCardDescription, { field: this.props.field }),
                    this.renderTypeSpecificFieldDetails(),
                    this.renderFieldDetailsLink()))));
    };
    return VizClientFieldCard;
}(React.Component));
exports.VizClientFieldCard = VizClientFieldCard;
//# sourceMappingURL=VizClientFieldCard.js.map